
import { createActionTypeModel } from "../../../../store/global/action-model";
// Type Container for ReleasesCatalog Action/Mutation Types. Use it in   releases/actions.js, releases/mutations.js and the Vuex Host Component 
export const ReleaseList = createActionTypeModel('ReleaseList');
export const ReleasesCatalogData = createActionTypeModel('ReleasesCatalogData');

export const ReleaseDetails = createActionTypeModel('ReleaseDetails');
export const Genres = createActionTypeModel('Genres');
export const RelatedLink = createActionTypeModel('RelatedLink');
export const ReleaseRelatedContacts = createActionTypeModel('ReleaseRelatedContacts');
export const ReleaseArtist = createActionTypeModel('ReleaseArtist');
export const ManualMatch = createActionTypeModel('ManualMatch');
export const RelatedFile = createActionTypeModel('RelatedFile');
export const RelatedProduct = createActionTypeModel('RelatedProduct');
export const Cost = createActionTypeModel('Cost');
export const SET_RELEASE_PRODUCT_FILES = 'SET_RELEASE_PRODUCT_FILES'

export const SET_RELEASE_ARTWORK = 'SET_RELEASE_ARTWORK';
export const UPDATE_RELEASE_DETAILS_STATE = 'UPDATE_RELEASE_DETAILS_STATE';

// Current ReleaseList -> CatalogReleasesList
// New ReleaseList for Metadata

